import { Injectable } from '@angular/core';
import { APIEndPoints } from 'src/app/utils/api-endpoint';
import { ApiHttpService } from '../../../Service/api.http.service';

@Injectable({
  providedIn: 'root',
})
export class DashBoardService {
  public weatherInfo;
  public weatherFutureInfo;
  public CenterInfo;
  interactionId: any;
  public IsSecureFileUpload: boolean = false;
  currentToDoTaskInfo;

  constructor(private _apiService: ApiHttpService) { }

  getPosition() {
    if (navigator.geolocation && !this.weatherInfo) {
      navigator.geolocation.getCurrentPosition(this.GetWeatherInfo.bind(this));
      navigator.geolocation.getCurrentPosition(this.GetWeatherFutureInfo.bind(this));
    }
  }

  private GetWeatherInfo(position) {
    if (!this.weatherInfo) {
      this._apiService
        .get(
          `${APIEndPoints.WeatherForecast}/current?Lat=${position.coords.latitude}&Lon=${position.coords.longitude}`
        )
        .subscribe(({ data }) => {
          this.weatherInfo = data;
        });
    }
  }
  private GetWeatherFutureInfo(position) {
    if (!this.weatherInfo) {
      this._apiService
        .get(
          `${APIEndPoints.WeatherForecast}/future?Lat=${position.coords.latitude}&Lon=${position.coords.longitude}`
        )
        .subscribe(({ data }) => {
          this.weatherFutureInfo = data;
        });
    }
  }
  GetAccessCode() {
    return this._apiService.get(`${APIEndPoints.Seclusion}/AccessCode`).pipe();
  }

  PostValidateCode(data) {
    return this._apiService
      .post(`${APIEndPoints.Seclusion}/AccessCodeValidate`, data)
      .pipe();
  }

  GetDigitalAssistInfo() {
    return this._apiService
      .get(APIEndPoints.DigitalAssistant + '/DigitalAssistants')
      .pipe();
  }

  GetDigitalAssistInfobyQuery(data) {
    return this._apiService
      .post(APIEndPoints.DigitalAssistant + '/FilterDigitalAssistants', data)
      .pipe();
  }

  GetDigitalAssistantFilters() {
    return this._apiService
      .get(APIEndPoints.DigitalAssistant + '/DigitalAssistantFilters')
      .pipe();
  }

  GetStateInfo(data) {
    return this._apiService
      .post(APIEndPoints.DigitalAssistant + '/StateInfo', data)
      .pipe();
  }

  GetToDoTasks() {
    return this._apiService.get(APIEndPoints.ToDoList + '/ToDoTaskList').pipe();
  }

  GetToDoTasksGroup() {
    return this._apiService.get(APIEndPoints.ToDoList + '/ToDoListGroup').pipe();
  }

  GetToDoListCustomGroup() {
    return this._apiService.get(APIEndPoints.ToDoList + '/ToDoListCustomGroup').pipe();
  }

  GetToDoSubTasks(taskId) {
    return this._apiService
      .get(APIEndPoints.ToDoList + '/ToDoSubTaskList/' + taskId)
      .pipe();
  }

  AddToDoList(data) {
    return this._apiService
      .post(APIEndPoints.ToDoList + '/AddToDo', data)
      .pipe();
  }

  DeleteToDoList(data) {
    return this._apiService
      .post(APIEndPoints.ToDoList + '/DeleteToDos', data)
      .pipe();
  }

  UpdateToDoList(id, data) {
    return this._apiService.put(APIEndPoints.ToDoList + '/' + id, data).pipe();
  }

  CompleteToDoList(data) {
    return this._apiService
      .post(APIEndPoints.ToDoList + '/CompleteToDo', data)
      .pipe();
  }
  SecureFileAccess(data) {
    return this._apiService
      .post(APIEndPoints.Files + '/SecureFileAccess', data)
      .pipe();
  }
  GetFileLinkStatus(id) {
    return this._apiService
      .get(`${APIEndPoints.Files}/GetFileLinkStatus/${id}`)
      .pipe();
  }

  FileUploadRequestAccessCode(id) {
    return this._apiService
      .get(`${APIEndPoints.Executor}/FileUploadRequestAccessCode/${id}`)
      .pipe();
  }

  OpenFileUpload(formData) {
    return this._apiService
      .post(`${APIEndPoints.Executor}/OpenFileUpload`, formData)
      .pipe();
  }
  AccessCodeValidate(data) {
    return this._apiService
      .post(APIEndPoints.Executor + '/AccessCodeValidate', data)
      .pipe();
  }
  PlanningSuggestion = [
    {
      icon: '/assets/images/lock-icon.svg',
      title: 'Personal Vault',
      content: 'A private storage space for you. You can upload and manage sensitive documents for your eyes only.',
      link: 'personalvault',
      video: 'https://player.vimeo.com/video/895776366?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
    },
    {
      icon: '/assets/images/movie-icon-20px.svg',
      title: 'Legacy Messages',
      content: 'A great way to leave behind a message to your loved ones, allowing you to share your story.',
      link: 'legacyvideo',
      video: 'https://player.vimeo.com/video/895778448?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
    }, {
      icon: '/assets/images/folder-icon-20px.svg',
      title: 'Family Access Files',
      content: 'Organize documents so the whole family has easy access to them on-the-go, like insurance cards or medical records.',
      link: 'files',
      video: 'https://player.vimeo.com/video/895778756?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
    }, {
      icon: '/assets/images/secure-icon.svg',
      title: 'Emergency Prep',
      content: 'Plan ahead for emergencies to ensure that your whole family knows how to get safe and reach each other.',
      link: 'emergency',
      video: 'https://player.vimeo.com/video/895779079?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
    }
  ]
}
